import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { startLoading, doneLoading } from '../../../utils/loading'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import { useParams } from 'react-router-dom'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import AssessmentOfWorkingWithThaiHealthWidget from '../../../widgets/assessment/AssessmentOfWorkingWithThaiHealthWidget'

export default function AssessmentOfWorkingWithThaiHealth() {
  const [isLoading, setIsLoading] = useState(false)
  const [schema, setSchema] = useState()
  const [error, setError] = useState()

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = mockSchemas //await getProjectOverview(projectId)
      setSchema(_schema)
    } catch (e) {
      console.log('e', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      <SidebarProposal>
        <ContentHeader header={schema.header} subHeader={schema.subHeader} />

        {/* ประเมินการการทำงานร่วมกับ */}
        {schema?.forms?.assessmentOfWorkingWithThaiHealth && (
          <>
            <AssessmentOfWorkingWithThaiHealthWidget
              schema={schema.forms.assessmentOfWorkingWithThaiHealth}
              showCommandButton={!schema.forms.assessmentOfWorkingWithThaiHealth.disabled}
              isEdit={true}
            />
            <br />
          </>
        )}
      </SidebarProposal>
    </>
  )
}

const mockSchemas = {
  header: 'ประเมินการการทำงานร่วมกับ สสส.',
  subHeader:
    'รหัสโครงการ 65-10079 : สร้างเสริมสุขภาพทั่วไป บ้านเวียงหมอก ตำบล ห้วยซ้อ อำเภอ เชียงของ จังหวัด เชียงราย',
  projecCode: 65 - 10079,
  projecName: 'สร้างเสริมสุขภาพทั่วไป บ้านเวียงหมอก ตำบล ห้วยซ้อ อำเภอ เชียงของ จังหวัด เชียงราย',
  disabled: false,
  formTemplate: 0,
  forms: {
    assessmentOfWorkingWithThaiHealth: {
      header: 'ประเมินการการทำงานร่วมกับ สสส.',
      rateData: {
        1: 'Useless',
        2: 'Poor',
        3: 'Ok',
        4: 'Good',
        5: 'Excellent',
      },
      datas: [
        {
          name: '1',
          label: 'ได้รับการอำนวนความสดวก กรุณาระบุ มากสุดจาก 5 ลงไปตามลำดับ',
          value: 5,
        },
        {
          name: '2',
          label: 'ความรวดเร็วนการดำเนินงานขั้นตอนต่างๆ กรุณาระบุ มากสุดจาก 5 ลงไปตามลำดับ',
          value: 5,
        },
        { name: 'projectNameTH', label: 'NNNNNN', value: 5 },
      ],
      otherIntroduce: {
        name: 'otherIntroduce',
        label: '4. อื่นๆ หรือแนะนำเพิ่มเติม',
        value: '',
        validators: [
          {
            type: 'MAXLENGTH',
            value: 4000,
            errorMessage: 'ชื่อโครงการเกินกำหนด 4,000 อักขระ',
          },
        ],
      },
    },
  },
}
